import styled from "styled-components";

export const SectionHeader = styled.h4`
  display: block;
  margin: 0;
  padding: 0 var(--mantine-spacing-sm);
  background-color: var(--mantine-color-blue-0);
  font-weight: 600;
`;
